import { useLanguage } from "../context/LanguageContext";
import { whatsappLink } from "../i18n/translations";
import { FAQAccordion } from "../components/FAQAccordion";
import { PricingTable } from "../components/PricingTable";
import { BookingCta } from "../components/BookingCta";

import heroImg from "../assets/img/reverse_handstand.jpeg";
import introImg from "../assets/img/trainer.jpg";
import outcome1 from "../assets/img/headstand.jpeg";
import outcome2 from "../assets/img/split.jpeg";
import outcome3 from "../assets/img/learning_split.jpeg";

export const Online = () => {
  const { t } = useLanguage();
  const o = t.online;

  const tiers = [
    { title: o.tier1Title, price: o.tier1Price, desc: o.tier1Desc },
    { title: o.tier2Title, price: o.tier2Price, desc: o.tier2Desc },
    { title: o.tier3Title, price: o.tier3Price, desc: o.tier3Desc },
  ];

  const faqItems = [
    { q: o.faq1Q, a: o.faq1A },
    { q: o.faq2Q, a: o.faq2A },
    { q: o.faq3Q, a: o.faq3A },
    { q: o.faq4Q, a: o.faq4A },
  ];

  return (
    <div className="page page-online">
      <section
        className="path-hero"
        style={{ backgroundImage: `linear-gradient(180deg, rgba(18,18,18,0.35), rgba(18,18,18,0.85)), url(${heroImg})` }}
      >
        <div className="path-hero-inner">
          <h1>{o.heroTitle}</h1>
          <p>{o.heroSubtitle}</p>
          <a
            className="btn btn-primary"
            href={whatsappLink(o.bookingMessage)}
            target="_blank"
            rel="noreferrer"
          >
            {o.heroCta}
          </a>
        </div>
      </section>

      <section className="section intro-section">
        <div className="intro-grid">
          <img src={introImg} alt="Natalia Nurgalieva" />
          <div>
            <h2>{o.introTitle}</h2>
            <p>{o.introText}</p>
          </div>
        </div>
      </section>

      <section className="section steps-section">
        <h2>{o.stepsTitle}</h2>
        <div className="steps-grid">
          <div className="step-card">
            <span className="step-number">1</span>
            <h3>{o.step1}</h3>
            <p>{o.step1Desc}</p>
          </div>
          <div className="step-card">
            <span className="step-number">2</span>
            <h3>{o.step2}</h3>
            <p>{o.step2Desc}</p>
          </div>
          <div className="step-card">
            <span className="step-number">3</span>
            <h3>{o.step3}</h3>
            <p>{o.step3Desc}</p>
          </div>
          <div className="step-card">
            <span className="step-number">4</span>
            <h3>{o.step4}</h3>
            <p>{o.step4Desc}</p>
          </div>
        </div>
      </section>

      <section className="section outcomes-section">
        <h2>{o.outcomesTitle}</h2>
        <div className="outcomes-grid">
          <div className="outcome-card">
            <img src={outcome1} alt={o.outcome1Title} />
            <h3>{o.outcome1Title}</h3>
            <p>{o.outcome1Desc}</p>
          </div>
          <div className="outcome-card">
            <img src={outcome2} alt={o.outcome2Title} />
            <h3>{o.outcome2Title}</h3>
            <p>{o.outcome2Desc}</p>
          </div>
          <div className="outcome-card">
            <img src={outcome3} alt={o.outcome3Title} />
            <h3>{o.outcome3Title}</h3>
            <p>{o.outcome3Desc}</p>
          </div>
        </div>
      </section>

      <section className="section trust-section">
        <h2>{o.trustTitle}</h2>
        <p>{o.trustDesc}</p>
      </section>

      <section className="section pricing-section">
        <h2>{o.pricingTitle}</h2>
        <PricingTable
          tiers={tiers}
          note={o.pricingNote}
          ctaLabel={o.pricingCta}
          ctaHref={whatsappLink(o.bookingMessage)}
        />
      </section>

      <section className="section faq-section">
        <h2>{o.faqTitle}</h2>
        <FAQAccordion items={faqItems} />
      </section>

      <BookingCta
        title={o.bookingTitle}
        subtitle={o.bookingSubtitle}
        whatsappHref={whatsappLink(o.bookingMessage)}
        whatsappLabel={o.bookingWhatsapp}
      />
    </div>
  );
};
